module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Histórico de leilões")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "informacoes-historico m-b-lg"
  }, [_c('div', [_vm._v("Essa GRV já foi incluída em "), _c('span', [_vm._v(_vm._s(_vm.historicoLeiloes.length))]), _vm._v(" leil" + _vm._s(_vm.historicoLeiloes.length === 1 ? 'ão' : 'ões'))])]), _vm._v(" "), (_vm.historicoLeiloes.length) ? _c('div', [_c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-whit b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("LEILÃO")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("DATA DE ABERTURA")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("NÚMERO DE LOTE")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoLeiloes), function(item) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', [(_vm.ACL.check('visualizar_leilao', _vm.currentUser.id)) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'leiloes.visualizar',
          params: {
            id: item.id
          }
        },
        "target": "_blank",
        "replace": ""
      }
    }, [_c('u', [_vm._v(_vm._s(item.titulo))])]) : _c('span', [_vm._v("(" + _vm._s(item.titulo) + ")")]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.Status[item.status].titulo) + ")")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatarData")(item.dataAbertura.date)))]), _vm._v(" "), _c('td', {
      style: ({
        'color': !item.numeroLote ? 'red' : 'black'
      })
    }, [(_vm.ACL.check('visualizar_leilao', _vm.currentUser.id)) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'lotes.visualizar',
          params: {
            leilao: item.id,
            id: item.loteId
          }
        },
        "target": "_blank",
        "replace": ""
      }
    }, [_c('u', [_vm._v(_vm._s(item.numeroLote || "Não numerado"))])]) : _c('span', [_vm._v("(" + _vm._s(item.numeroLote || "Não numerado") + ")")])], 1)])
  }), 0)])]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b92778e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/HistoricoLeiloesGrv.vue
// module id = 1976
// module chunks = 0